import type React from 'react'
import { memo, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { getDialogId, getModalOptions } from '@/components/composed/Modal/reducer'
import type { RootState } from '@/redux/interfaces'
import type { IUserRegionSelectSelectorProps } from '../types'
import { UserRegionChooserModal } from './UserRegionChooserModal'

addModalToWellKnown({ UserRegionChooserModal })

const mapState = (state: RootState) => ({
  actualDialogId: getDialogId()(state),
  isActualDialogOpened: getModalOptions()(state).isOpened,
})

const UserRegionSelectSelectorDesktop: React.FC<IUserRegionSelectSelectorProps> = props => {
  const { value, onInput, isShown, onClose } = props
  const dispatch = useDispatch()
  const { actualDialogId, isActualDialogOpened } = useSelector(mapState)

  const actualDialogIdIsRegionModal = useMemo(() => actualDialogId === 'UserRegionChooserModal', [actualDialogId])

  const closeUserRegionChooserModal = () => {
    if (actualDialogIdIsRegionModal && isActualDialogOpened) {
      dispatch(closeModal())
    }
  }

  const openUserRegionChooserModal = () => {
    if (actualDialogIdIsRegionModal && isActualDialogOpened) return

    dispatch(
      openModal({
        options: {
          dialogId: 'UserRegionChooserModal',
          onCloseModal: () => onClose(),
        },
        contentOptions: { value, onInput },
      }),
    )
  }

  useEffect(() => {
    if (isShown) {
      openUserRegionChooserModal()
    } else {
      closeUserRegionChooserModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShown])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => closeUserRegionChooserModal(), [actualDialogIdIsRegionModal])

  return null
}

export default memo(UserRegionSelectSelectorDesktop)
